import { createFileRoute } from "@tanstack/react-router";

import VipPage from "./-components/VipPage";

export const Route = createFileRoute("/_app/_dashboard/profile/vip")({
  component: VipPage,
});
